import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Login } from '../models/login';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private login = new BehaviorSubject(null);
  currentLogin = this.login.asObservable();

  constructor() { }

  changeLogin(login: Login) {
    this.login.next(login);
  }
}
